import { render } from "./PrintReceipt.vue?vue&type=template&id=4b324644&scoped=true"
import script from "./PrintReceipt.vue?vue&type=script&lang=js"
export * from "./PrintReceipt.vue?vue&type=script&lang=js"

import "./PrintReceipt.vue?vue&type=style&index=0&id=4b324644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b324644"]])

export default __exports__